/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import classNames from 'classnames';

import { CopySingleResponseLazy } from 'bundles/ai-coach-platform/components/building-blocks';
import { useCoachChatContext } from 'bundles/ai-coach-platform/components/patterns/chat/context/CoachChatContext';
import StoreProviderWrapper from 'bundles/ai-coach-platform/components/patterns/chat/store/StoreProviderWrapper';
import type { MessageTypes } from 'bundles/ai-coach-platform/components/patterns/chat/store/types';

import Feedback from '../../Feedback';

const styles = {
  root: css`
    display: flex;
    align-items: center;
  `,
};

type Props = {
  message?: MessageTypes;
  children?: React.ReactNode;
  className?: string;
  showCopyMessage?: boolean;
  showFeedback?: boolean;
};

/**
 * Renders footer actions for a chat message such as feedback actions for Coach message
 */
export const ChatMessageFooter = (props: Props): React.ReactElement => {
  const { message, children, showCopyMessage = true, showFeedback = true, className = '' } = props;
  const { isBrandUpdateEnabled } = useCoachChatContext();

  const defaultFooter = (
    <StoreProviderWrapper>
      <React.Suspense fallback={null}>
        {message && showCopyMessage && (
          <CopySingleResponseLazy message={message.text} size={20} isBrandUpdateEnabled={isBrandUpdateEnabled} />
        )}
        {showFeedback && <Feedback message={message as MessageTypes} />}
      </React.Suspense>
    </StoreProviderWrapper>
  );

  return (
    <div className={classNames('chat-message-footer', className)} css={styles.root}>
      {children ?? defaultFooter}
    </div>
  );
};

export default ChatMessageFooter;
